class ImagePillarsSection extends HTMLElement {
  connectedCallback() {
    this.media = this.querySelector('[data-image-pillars-media]');
    this.grid = this.querySelector('.image-pillars__grid');
    if (!this.media) return;

    this.collectItemSlides();
    this.updateMediaVisibility();
    this.syncFromOpenAccordion();

    this.onToggle = this.onToggle.bind(this);
    this.onBlockSelect = this.onBlockSelect.bind(this);

    this.addEventListener('toggle', this.onToggle, true);
    document.addEventListener('shopify:block:select', this.onBlockSelect);
  }

  disconnectedCallback() {
    this.removeEventListener('toggle', this.onToggle, true);
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
  }

  collectItemSlides() {
    this.querySelectorAll('[data-image-pillars-slide-template]').forEach((template) => {
      if (!(template instanceof HTMLTemplateElement)) return;
      this.media.appendChild(template.content);
      template.remove();
    });
  }

  updateMediaVisibility() {
    const hasSlides = Boolean(this.media.querySelector('[data-image-pillars-slide]'));
    this.media.classList.toggle('image-pillars__media--empty', !hasSlides);
    this.grid?.classList.toggle('image-pillars__grid--single', !hasSlides);
  }

  onToggle(event) {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.open) return;
    if (!this.contains(details)) return;

    this.showSlideForItem(details.closest('[data-image-pillars-item]'));
  }

  onBlockSelect(event) {
    const target = event.target;
    if (!(target instanceof HTMLElement) || !this.contains(target)) return;

    const item = target.closest('[data-image-pillars-item]');
    if (!item) return;

    this.showSlideForItem(item);

    const details = item.querySelector('details');
    if (!(details instanceof HTMLDetailsElement) || details.open) return;

    const summary = details.querySelector('summary');
    if (summary instanceof HTMLElement) {
      summary.click();
    }
  }

  syncFromOpenAccordion() {
    const openDetails = this.querySelector('.image-pillars__details[open]');
    const item = openDetails instanceof HTMLElement ? openDetails.closest('[data-image-pillars-item]') : null;
    this.showSlideForItem(item);
  }

  showSlideForItem(item) {
    const itemId = item instanceof HTMLElement ? item.dataset.imagePillarsItem : '';
    this.showSlide(itemId);
  }

  showSlide(itemId) {
    const slides = this.media.querySelectorAll('[data-image-pillars-slide]');
    if (!slides.length) return;

    const requested = itemId
      ? this.media.querySelector(`[data-image-pillars-slide="${CSS.escape(itemId)}"]`)
      : null;
    const fallback = this.media.querySelector('[data-image-pillars-slide="fallback"]');
    const target = requested || fallback || this.media.querySelector('.image-pillars__slide.is-active') || slides[0];

    slides.forEach((slide) => {
      const isActive = slide === target;
      slide.classList.toggle('is-active', isActive);
      if (isActive) {
        slide.removeAttribute('aria-hidden');
      } else {
        slide.setAttribute('aria-hidden', 'true');
      }
    });
  }
}

if (!customElements.get('image-pillars-section')) {
  customElements.define('image-pillars-section', ImagePillarsSection);
}
